import React from 'react';
import { ServerService } from './../../../services/server.service';
import { AuditLog } from './../../../services/auditlog.service';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import { getPsswdStrength, removeSpecialCharacter } from '../../../utility/utility';
import { getMessage } from '../../../constants/messagesMapper';

class Setting extends React.Component {
    constructor(props) {
        super(props);
        let server = JSON.parse(sessionStorage.server);
        let migServer;
        try {
            migServer = JSON.parse(sessionStorage.migServer);
        } catch(err) {
        }
        this.state = {
            isdatapresent: false,
            name: server.instance.name,
            password: '',
            inputName: removeSpecialCharacter(server.instance.name),
            nameErrorMessg: '',
            psswdErrorMessg: '',
            psswdStrength: 'Weak',
            isPsswdText: false,
            nameErrorMsg: '',
            isNameError: false,
            rootErr: false,
            eightCharLi: false,
            oneUpperLi: false,
            oneNumSpeLi: false,
            noNumSpeLi: false,
            flavorId: this.props.instance.flavor.id,
            migServer: migServer,
            migList: []
        };
    }


    handler = (event) => {
        let val = event.target.value;
        if(event.target.name === 'password') {
            this.setState({ psswdStrength: getPsswdStrength(val) });
            var middleCharPatt = new RegExp("[A-Z]");
            var str = val;
            var lastChar = str.charAt(str.length - 1);
            //At least 8 characters long
            if(val.length >= 8) {
                this.setState({
                    eightCharLi: true
                });
            } else {
                this.setState({
                    eightCharLi: false
                });
            }
            var str2 = str.slice(1, -1);
            //Must contain 1 uppercase (first and last characters don’t count)
            if(middleCharPatt.test(str2)) {
                this.setState({
                    oneUpperLi: true
                });
            } else {
                this.setState({
                    oneUpperLi: false
                });
            }
            //Must contain 1 number and 1 special character
            var patt2 = new RegExp("(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])");
            if(patt2.test(str)) {
                this.setState({
                    oneNumSpeLi: true
                });
            } else {
                this.setState({
                    oneNumSpeLi: false
                });
            }
            //Cannot end in a number or special character            
            var lastCharPatt = new RegExp("[A-Za-z]");
            if(lastCharPatt.test(lastChar)) {
                this.setState({
                    noNumSpeLi: true
                });
            } else {
                this.setState({
                    noNumSpeLi: false
                });
            }
        }
        if(event.target.name === "inputName") {
            this.setState({ isNameError: false });
            if(val.length > 50) {
                return;
            }
            var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
            if(!nameRegex.test(val)) {
                this.setState({ nameErrorMsg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', isNameError: true });
            } else {
                this.setState({ nameErrorMsg: '', isNameError: false });
            }
        }
        if(event.target.name === "password") {
            this.setState({
                rootErr: false
            });
        }
        this.setState({ [event.target.name]: val });
    };

    nameSaveClick = () => {
        let trimName = this.state.inputName.trim();
        if(trimName === '') {
            this.setState({ nameErrorMsg: 'Enter a new label', isNameError: true });
            document.getElementById("name").focus();
            return;
        }
        if(this.state.inputName.length > 50) {
            this.setState({ nameErrorMsg: 'Name should not be more than 50 characters', isNameError: true });
            document.getElementById("name").focus();
            return;
        }
        if(this.state.name === trimName) {
            this.setState({ nameErrorMsg: 'Name should not be duplicate', isNameError: true });
            document.getElementById("name").focus();
            return;
        }
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        if(!nameRegex.test(trimName)) {
            this.setState({ nameErrorMsg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)', isNameError: true });
            document.getElementById("name").focus();
            return;
        }
        this.setState({ nameErrorMessg: '' });
        this.props.bgShadowHandler(true);
        let requestBody = { server: { name: trimName } };
        let i18n = this.props.i18n;
        ServerService.updateServer(this.props.instanceId, this.props.computeRegionUrl, requestBody).then(resp => {
            if(resp && resp.server) {
                let server = JSON.parse(sessionStorage.server);
                server.instance = resp.server;
                sessionStorage.server = JSON.stringify(server);
                const requestbdy = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance renamed from " + this.state.name + " to " + requestBody.server.name,
                    "operation": "Instance Rename"
                };
                AuditLog.storeAuditLogs(requestbdy, "instance").then((resp) => {
                    this.props.bgShadowHandler(false);
                    if(resp === false);
                });
                this.setState({ name: trimName, inputName: trimName });
                this.props.updateInstData(resp.server);
                this.props.msgHandler(i18n.t('inst_sett_rename_success'), 'success');
                this.clearToastMessage();
                return;
            }
            // if(resp && resp.conflictRe)
            this.props.bgShadowHandler(false);
            this.props.msgHandler(i18n.t('inst_sett_rename_failure'), 'error');
            this.clearToastMessage();
        });
    };

    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.loadMigList();
        document.getElementById("name").focus();
    }

    loadMigList() {
        ServerService.getCloneList('migration').then(resp => {
            if(Array.isArray(resp)) {
                this.setState({ migList: resp });
            }
        });
    }

    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };

    componentWillUnmount() {
        this.props.msgHandler();
    }

    getFlavorDetails(flavorId) {
        let flavorList = JSON.parse(localStorage.getItem('flavorListDb'));
        if(flavorList !== null && flavorList !== undefined) {
            let flavorObj = undefined;
            try {
                flavorObj = flavorList.find(item => item.flavour_id === flavorId);
            }
            catch(err) {
                return false;
            }

            if(flavorObj === undefined) {
                return false;
            }
            let nameArr = flavorObj.name.split(' ');
            if(nameArr[0].includes('SCPU')) {
                return false;
            }
            if(nameArr[0].includes('DCPU')) {
                return false;
            }
            if(nameArr[0].includes("BM")) {
                return true;

            }

        }
        return false;
    }

    passwdSaveClick = () => {

        if(this.state.password.trim() === '') {
            this.setState({ rootErr: true });
            document.getElementById("passwd").focus();
            return;
        }
        if(this.state.psswdStrength === 'Weak') {
            document.getElementById("passwd").focus();
            return;
        }
        this.setState({ psswdErrorMessg: '' });
        this.props.bgShadowHandler(true);
        let requestBody = { changePassword: { adminPass: this.state.password.trim() } };
        let i18n = this.props.i18n;
        ServerService.serverAction(this.props.instanceId, this.props.computeRegionUrl, requestBody).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp === '') {
                console.log(resp);
                this.setState({ password: '', psswdStrength: 'Weak' });
                this.props.msgHandler(i18n.t('inst_sett_psswd_success'), 'success');
                this.clearToastMessage();
                return;
            }
            if(!resp) {
                this.props.msgHandler(i18n.t('inst_sett_psswd_failure'), 'error');
                this.clearToastMessage();
                return;
            }
            if(resp && resp.conflictingRequest) {
                let newMsg = getMessage(resp.conflictingRequest.message);
                if(newMsg.includes(this.props.instanceId)) {
                    this.props.msgHandler(i18n.t('inst_sett_psswd_failure'), 'error');
                    this.clearToastMessage();
                } else {
                    this.props.msgHandler(newMsg, 'error');
                    this.clearToastMessage();
                }
                return;
            }
            this.props.msgHandler(i18n.t('inst_sett_psswd_failure'), 'error');
            this.clearToastMessage();
        });
    };

    moveToIndex() {
        localStorage.removeItem("serverlist" + localStorage.getItem("userId"));
        this.props.history.push('/index');
    }

    deleteClick = () => {
        this.props.bgShadowHandler(true);
        this.deleteClose();
        let i18n = this.props.i18n;
        ServerService.deleteServer(this.props.instanceId, this.props.computeRegionUrl).then(resp => {
            if(resp === 204) {
                const requestBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.state.name + " has been deleted",
                    "operation": "Instance Delete"
                };
                AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {
                    if(resp === false);
                });
                setTimeout(() => {
                    this.props.bgShadowHandler(false);
                    this.moveToIndex();
                }, 2000);
                this.props.msgHandler(i18n.t('inst_delete_success').replace('name', this.state.name), 'success');
                this.clearToastMessage();
                return;
            }
            this.props.bgShadowHandler(false);
            this.props.msgHandler(i18n.t('inst_action_failure').replace('action', 'delete'), 'error');
            this.clearToastMessage();

        });
    };

    deleteClose = () => {
        $('#delInst').removeClass('active');
    };

    deleteBttnClick = () => {
        if(this.state.migList && this.state.migList.length > 0) {
            let a = this.state.migList.find(item => item.srcInstId === this.props.instance.id);
            if(a !== undefined) {
                this.props.msgHandler('The instance cannot be deleted as the migration is in progress', 'error');
            }
            return;
        }
        if(this.state.migServer) {
            $('#cnfmDelMig').addClass('active');
            return;
        }
        $('#delInst').addClass('active');
        document.getElementById('setDelBtn').focus();
    };
    onSettingsKeydown = (e, type) => {
        if(e.keyCode === 13 && this.props.isTaskStateNull) {
            if(type === 'name') {
                this.nameSaveClick();
            } else if(type === 'psswd') {
                this.passwdSaveClick();
            }
        }
    };
    checkBm = (flavorId) => {
        try {
            let flavorList = JSON.parse(localStorage.getItem('BMflavors'));

            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.id === flavorId);
                }
                catch(err) {
                    return true;
                }

                if(flavorObj === undefined) {
                    return true;
                }


                if(flavorObj.type == "BM") {
                    return false;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return true;
            }
        } catch(e) {

        }
        return true;
    };
    confirmMigration(event) {
        event.preventDefault();
        let migServer = this.state.migServer;
        let migInstUrl = migServer.computeRegionUrl;
        $('#cnfmDelMig').removeClass('active');
        this.props.bgShadowHandler(true);
        ServerService.migration(migServer.id, migInstUrl, this.props.computeRegionUrl, 'metadata').then(resp => {
            if(resp === 'success') {
                this.props.msgHandler('Instance is confirmed for the migration.', 'success');
                this.props.bgShadowHandler(false);
                setTimeout(() => {
                    this.moveToIndex();
                }, 100);
                return;
            }
            this.props.bgShadowHandler(false);
            this.props.msgHandler('Failed to confirmed the migration.', 'error');
        });
        event.stopPropagation();
    }
    render() {
        let isRancher = this.props.instance.metadata?.instType === 'rancher';
        return (
            <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper instaceSettng_setting_module" }>
                { this.state.isdatapresent ? <div>
                    <div className="outer_empty_wrap">
                        <div className="inner_empty_wrap">
                            <div className="svg_wrap empty_icon settings_empty"></div>
                            <p className="empty_title">No Settings</p>
                        </div>
                    </div>
                </div> : <div>

                    <div className="settModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>Settings</h2>
                            <p className="head_info">Manage the settings of the compute instance</p>
                        </div>
                    </div>
                    <div className="settingModule_wrap clearfix">
                        <div className="avail_setting_wrap">
                            <div className="setting_box_wrap label_settng_wrap clearfix active">
                                <h2>Rename Instance</h2>
                                <p className="title_txt" >Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)</p>
                                <div className="common_txtBox_row">
                                    {/* <label>Name Label</label> */ }
                                    <input type="text" id="name" autoComplete="off" name="inputName" value={ this.state.inputName } placeholder="Assign a new label for the instance"
                                        onChange={ this.handler } className="txtBox" onKeyDown={ (e) => this.onSettingsKeydown(e, 'name') } tabIndex="1" />
                                    <span className="comm_error_msg" style={ { display: this.state.isNameError ? "block" : "none" } }>{ this.state.nameErrorMsg }</span>
                                </div>
                                <input tabIndex="2" className={ !this.props.isTaskStateNull ? "common_cta_btn blue save_btn disabled" : "common_cta_btn save_btn blue" } disabled={ !this.props.isTaskStateNull }
                                    type="button"
                                    name=""
                                    value="Save" onClick={ () => this.nameSaveClick() } />
                            </div>
                            <div className="setting_box_wrap resetPwd_settng_wrap active" style={ { display: this.getFlavorDetails(this.state.flavorId) || isRancher ? "none" : "" } }>
                                <span className="comm_error_msg">{ this.state.psswdErrorMessg }</span>
                                <h2>Reset root password</h2>
                                {/* <p className="title_txt">Provide a new root password</p> */ }
                                <section className="authenticate_sec">
                                    {/* <label>New root password</label> */ }
                                    <div className="inp_row auth_inp_row">
                                        <div className="auth_box_wrap">
                                            <input autoComplete="off" type={ this.state.isPsswdText ? "text" : "password" } id="passwd" name="password" value={ this.state.password } placeholder="Provide a new root password"
                                                onChange={ this.handler } className="txt_box" onKeyDown={ (e) => this.onSettingsKeydown(e, 'psswd') } tabIndex="3" />
                                            <span data-tip data-for="password" className={ this.state.isPsswdText ? "pwd_field show_pwd" : "pwd_field" } onClick={ () => this.setState({ isPsswdText: !this.state.isPsswdText }) }></span>
                                            <ReactToolTip id="password" place="right" effect="solid">
                                                { this.state.isPsswdText ? "Hide" : "Show" }
                                            </ReactToolTip>
                                        </div>
                                        {/* <span
                                                className="question_icon"
                                                data-tip  data-for = "previlige">
                                                <svg
                                                    x="0px"
                                                    y="0px"
                                                    viewBox="0 0 22 20"
                                                    enableBackground="new 0 0 22 20"
                                                    xmlSpace="preserve">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        fill="#89A2BE"
                                                        d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                    <text
                                                        transform="matrix(1 0 0 1 7.0724 15.4681)"
                                                        fill="#FFFFFF"
                                                        fontFamily="'Roboto-Medium'"
                                                        fontSize="16px">?</text>
                                                </svg>
                                            </span>
                                            <ReactToolTip  id="previlige" multiline = {true} place="right" effect="solid">
                                                            The root password is used to offer privileged <br></br>root access to a user to make full use of all the resources of the virtual instance. 
                                                        </ReactToolTip> */}
                                        <span className="comm_error_msg" style={ { display: this.state.rootErr ? "block" : "none" } }>Enter a new root password</span>
                                        <div className="auth_progress" style={ { display: (this.state.password ? '' : 'none') } }>
                                            <div className="progress_wrap">
                                                <div className="progress_bar">
                                                    { this.state.psswdStrength === 'Weak' && (<span
                                                        className="percent_progress"
                                                        style={ {
                                                            width: "10%"
                                                        } }></span>)
                                                    }
                                                    { this.state.psswdStrength === 'Strong' && (<span
                                                        className="percent_progress"
                                                        style={ {
                                                            width: "100%", background: 'green'
                                                        } }></span>)
                                                    }
                                                </div>
                                                <span className="progress_content" style={ { color: (this.state.psswdStrength === 'Strong' ? 'green' : '#f6ac39') } }>{ this.state.psswdStrength }</span>
                                            </div>
                                            { this.state.psswdStrength === 'Weak' && (<p>Your password is weak. Choose a stronger password.</p>) }
                                            { this.state.psswdStrength === 'Weak' && (<h4>Password requirements</h4>) }
                                            { this.state.psswdStrength === 'Weak' && (
                                                <ul>
                                                    <li className={ this.state.eightCharLi ? "p_success" : "" }>At least 8 characters long</li>
                                                    <li className={ this.state.oneUpperLi ? "p_success" : "" }>Must contain 1 uppercase (first and last characters don’t count)</li>
                                                    <li className={ this.state.oneNumSpeLi ? "p_success" : "" }>Must contain 1 number and 1 special character</li>
                                                    <li className={ this.state.noNumSpeLi ? "p_success" : "" }>Cannot end in a number or special character</li>
                                                    {/* <li className="p_success">Cannot end in a number or special character</li> */ }
                                                </ul>
                                            ) }
                                        </div>

                                    </div>

                                </section>
                                <input tabIndex="4" className={ (!this.props.isTaskStateNull || this.state.psswdStrength === 'Weak') ? "common_cta_btn blue save_btn disabled" : "common_cta_btn  save_btn blue" } disabled={ !this.props.isTaskStateNull || this.state.psswdStrength === 'Weak' }
                                    type="button"
                                    name=""
                                    value="Save"
                                    onClick={ () => this.passwdSaveClick() } />
                            </div>
                            <div className="setting_box_wrap delete_settng_wrap clearfix active">
                                <h2>Delete Instance</h2>
                                <p className="title_txt ">This will permanently delete the instance from your account and all its data will be erased and become unrecoverable. However, the resources associated with this instance will not be automatically deleted unless you delete them manually,
                                    and you may continue to be billed for them. This operation is irreversible.</p>
                                <input type="button" className={ !this.props.isTaskStateNull || this.props.instance.metadata?.opType === 'migration' ? "common_cta_btn blue delete_btn disabled" : "common_cta_btn delete_btn blue" } disabled={ !this.props.isTaskStateNull || this.props.instance.metadata?.opType === 'migration' }
                                    name="" value="Delete" tabIndex="5"
                                    onClick={ this.deleteBttnClick } />
                            </div>
                        </div>
                    </div>
                </div>
                }
                <div className="main_popup delete_instanceSetting_popup" id="delInst">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ this.deleteClose }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                { !this.checkBm(this.state.flavorId) ?
                                    <div className="popup_body">
                                        <p className="imp_warn_note"><strong>Warning: </strong>This will permanently delete the bare metal instance from your account with all its data.

                                            The Bare Metal server will be released from your account and you may have to request for new server for new bare metal instance.</p>
                                        <p>Are you sure you want to delete the instance <b>{ this.state.name }</b> ?</p>
                                        <p><strong>Note:</strong> Any charges incurred will not be refunded on deleting the instance.</p>
                                    </div>
                                    :
                                    <div className="popup_body">
                                        <p>Are you sure you want to delete the instance <b>{ this.state.name }</b> ?</p>
                                        <p><strong>Note:</strong> Any charges incurred will not be refunded on deleting the prepaid yearly instance.</p>
                                    </div>
                                }

                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" onClick={ this.deleteClick } id="setDelBtn" >Delete</button>
                                        <button className="btn btn_cancel" onClick={ this.deleteClose } >Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_popup delete_instance_popup" id="cnfmDelMig">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="tipcnfmMig1" onClick={ () => { $('#cnfmDelMig').removeClass('active'); } }>
                            </span>
                                <ReactToolTip place="left" effect="solid" id="tipcnfmMig1">Close</ReactToolTip>
                                <div className="popup_header">
                                    <div className="sub_title"> Confirm Migration</div>
                                </div>
                                <div className="popup_body">
                                    <p className="imp_warn_note"><strong>Warning: </strong>This will permanently delete the instance from your account. On removing the instance, all its data and stored information will be deleted. This operation is irreversible.</p>
                                    <p> On deleting the source instance <strong> { this.props.instance.name } </strong>, the migrated instance <strong>{ this.state.migServer?.name }</strong> with IP address <strong>{ this.state.migServer?.mainIpAddress }</strong> in region<strong> { this.state.migServer?.fullRegion }</strong> will be confirmed for the migration. This action is irreversible. </p>
                                    <p>Are you sure you want to proceed?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn blue" onClick={ (e) => this.confirmMigration(e) }>Confirm</div>
                                        <div className="btn btn_cancel" onClick={ () => { $('#cnfmDelMig').removeClass('active'); } }>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        );
    }
}

export default Setting;
